import axios from 'axios';
import { apiService } from './api.service';
import { DpdParcelShopResponseModel } from 'models/dpd-parcel-shop';
import {extractData, handleApiException, handleResponse} from '../helpers/apiResponseHelper';

async function getDpdParcelShops(): Promise<DpdParcelShopResponseModel[]> {
  return axios.get(`${apiService.getApiUrl()}/dpd/parcel-shops`)
      .then(handleResponse)
      .then(extractData)
      .catch(handleApiException);
}

const DpdParcelShopService = {
  getDpdParcelShops,
};

export default DpdParcelShopService;
